import { ControlType, v2 } from '@sap/ux-specification-types';
import type { ResponsiveTable, TreeTable, AnalyticalTable, GridTable } from '../controls/Table';
import { pageLayoutInformation, childId, syncRule } from '../../../common/decoration/decorators';
import { buildControlIdForPage } from '../../../common/decoration';

type TableClassType = ResponsiveTable | TreeTable | AnalyticalTable | GridTable;

@pageLayoutInformation({
    id: v2.SAPUI5_VIEW_EXTENSION_LIST_REPORT,
    pageId: v2.FE_TEMPLATE_V2_LIST_REPORT
})
export class ListReport implements v2.ListReportConfigV2 {
    @syncRule({
        flex: {
            controlId: buildControlIdForPage,
            controlType: (): ControlType => ControlType.DynamicPage
        }
    })
    fitContent?: boolean;

    @childId('listReportFilter')
    filterBar?: v2.ListReportFilterBar;

    @childId('listReport')
    table?: TableClassType;

    @childId('listReportFooter')
    footer?: v2.GenericFooter;
}
